import { PropsWithChildren, useCallback } from "react";

import RCUpload from "rc-upload";

import { RcFile, UploadRequestOption } from "rc-upload/lib/interface";
import { Box } from "@mui/system";

interface Props extends PropsWithChildren {
  onStart?: (file: File) => Promise<void> | void;
  onUpload?: (options: UploadRequestOption) => Promise<void> | void;
  onSuccess?: (res: any, file: File) => Promise<void> | void;
  acceptedFileExtensions?: string[];
}

const UploadWrapper = (props: Props) => {
  const {
    onStart,
    onUpload,
    onSuccess,
    acceptedFileExtensions = [".eps", ".svg"],
    children,
  } = props;

  const customRequest = useCallback(
    (options: any) => {
      onUpload?.(options);
    },
    [onUpload]
  );

  const rcUploadProps = {
    multiple: false,
    accept: acceptedFileExtensions.join(", "),
    onStart: async (file: RcFile) => {
      if (onStart) {
        await onStart(file);
      }
    },
    onSuccess: async (res: any, file: File) => {
      console.log(res, file);
      if (onSuccess) {
        await onSuccess(res, file);
      }
    },
    customRequest: customRequest,
    component: "div",
  };

  return (
    <Box>
      <RCUpload {...rcUploadProps}>{children}</RCUpload>
    </Box>
  );
};

export default UploadWrapper;
